module.exports = __webpack_public_path__ + "img/38.e994874d.jpg";